<template lang="pug">
li.post-list-item(
  :id="`post-${post.id}`"
  :class="classes"
  :title="tooltipText"
)
  router-link.post-list-item__link(
    tag="span"
    :to="route"
  )

  span.post-list-item__type.post-type-icon {{ typeIcon }}
  
  router-link.post-list-item__title.post-title(
    :to="route"
  ) {{ post.title }}

  post-author.post-list-item__author(
    hide-by
    hide-name
    :author="author"
  )
</template>

<script>
import PostResourceMixin from '@/mixins/postResource'
import PostAuthor from '@/components/post/post-author'

export default {
  name: 'post-list-item',
  components: {
    PostAuthor,
  },
  mixins: [PostResourceMixin],
  computed: {
    classes() {
      return {
        '--media': this.post.type === 'media',
        '--article': this.post.type === 'article',
      }
    },
    typeIcon() {
      switch (this.post.type) {
        case 'media':
          return '🖻'
        case 'article':
        default:
          return '🖹'
      }
    },
    tooltipText() {
      return this.hasSubtitle ? `${this.post.title} : ${this.post.subtitle}` : this.post.title
    },
    hasSubtitle() {
      return !!this.post.subtitle
    },
    postAuthorName() {
      return this.author.name
    },
  },
}
</script>

<style lang="sass">
/* see App.vue for these root styles:
  --post-title-font-size: 3rem
  --post-title-line-height: 1.4 */

.post-list-item
  --post-title-font-size: 1.4rem
  --post-title-line-height: 1

.post-list-item
  position: relative
  list-style: none
  display: flex
  align-items: center
  border: 1px solid var(--base-color)
  margin-bottom: 1rem
  padding: .4rem .8rem
  cursor: pointer

.post-list-item__link
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  z-index: 0

.post-list-item__type
  font-size: var(--post-title-font-size)
  line-height: var(--post-title-line-height)
  margin-right: .8rem

.post-list-item__author
  position: relative
  margin-left: auto

.post-list-item__title:visited
  color: var(--base-color-light)

.post-list-item__link:hover ~ .post-list-item__title,
.post-list-item__title:hover,
.post-list-item__title:focus
  color: var(--accent-color)

</style>